<template>
  <DashboardWidget canGoFullscreen title="Conto Economico Annuale" class="conto-economico-widget no-overflow">
    <OperativeTable dense>
      <tbody>
        <OperativeTableBodyRow :values="[values.ricavi]">
          Ricavi
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaScorte]">
          ∆ Scorte
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.cogs]">
          Cogs
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.grossMargin]" strong>
          Gross Margin
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>

        <OperativeTableBodyRow :values="[values.personale]">
          Personale
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.ga]">
          G&A
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.ebitda]" strong>
          EBITDA
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>

        <OperativeTableBodyRow :values="[values.ammortamenti]">
          Ammortamenti e acc.
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.ebit]" strong>
          EBIT
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>

        <OperativeTableBodyRow :values="[values.costiFinanziari]">
          Costi finanziari
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.ebt]" strong>
          EBT
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>

        <OperativeTableBodyRow :values="[values.creditoImposta]">
          Credito d'imposta
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.tasse]">
          Tasse
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.risultato]" strong>
          Risultato Netto
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
      </tbody>
    </OperativeTable>

    <template #fullscreen>
      <OperativeTable>
        <tbody>
        <OperativeTableBodyRow :values="[values.ricavi]">
          Ricavi
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.deltaScorte]">
          ∆ Scorte
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.cogs]">
          Cogs
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.grossMargin]" strong>
          Gross Margin
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.personale]">
          Personale
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.ga]">
          G&A
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.ebitda]" strong>
          EBITDA
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.ammortamenti]">
          Ammortamenti e acc.
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.ebit]" strong>
          EBIT
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.costiFinanziari]">
          Costi finanziari
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.ebt]" strong>
          EBT
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.creditoImposta]">
          Credito d'imposta
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.tasse]">
          Tasse
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        <OperativeTableBodyRow :values="[values.risultato]" strong>
          Risultato Netto
          <template #cell-content="{ value }">{{ value | money }}</template>
        </OperativeTableBodyRow>
        </tbody>
      </OperativeTable>
    </template>
  </DashboardWidget>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  components: {
    DashboardWidget: () => import('./DashboardWidget'),
    OperativeTable: () => import('../../Operative/OperativeTable'),
    OperativeTableBodyRow: () => import('../../Operative/OperativeTableBodyRow'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
  },
};

</script>

<style lang="scss">

.conto-economico-widget {
  .operative-table-value-column {
    min-width: 1px;
  }
}

</style>
